/** Cantidades tactiles: botones ≥44px + entrada decimal directa. */
import { clsx } from 'clsx';

export function QuantityStepper({
  label,
  value,
  onChange,
  compact = false,
}: {
  label: string;
  value: number;
  onChange: (next: number) => void;
  /** Variante estrecha para tarjetas compactas; conserva objetivos de 44 px. */
  compact?: boolean;
}) {
  return (
    <div className={clsx('flex items-center', compact ? 'gap-1.5' : 'gap-3')}>
      <button
        type="button"
        aria-label={`Disminuir cantidad de ${label}`}
        disabled={value <= 0}
        onClick={() => onChange(Math.max(0, value - 1))}
        className="h-11 w-11 rounded-full border border-border-light bg-bg-tertiary text-xl text-text-primary transition-colors hover:bg-border-light disabled:opacity-40"
      >
        −
      </button>
      <input
        type="text"
        inputMode="decimal"
        aria-label={`Cantidad de ${label}`}
        value={String(value)}
        onChange={(e) => {
          const parsed = Number(e.target.value.replace(',', '.'));
          onChange(Number.isFinite(parsed) && parsed >= 0 ? parsed : 0);
        }}
        className={clsx(
          'h-11 rounded-xl border border-border text-center text-base tabular-nums',
          compact ? 'w-12 px-1' : 'w-16',
        )}
      />
      <button
        type="button"
        aria-label={`Aumentar cantidad de ${label}`}
        onClick={() => onChange(value + 1)}
        className="h-11 w-11 rounded-full border border-border-light bg-bg-tertiary text-xl text-text-primary transition-colors hover:bg-border-light"
      >
        +
      </button>
    </div>
  );
}
